/**
 * API service for visitor count
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';
// No key in source: set VITE_API_KEY in .env.local (dev) or .env.production.local (deploy build).
const API_KEY = import.meta.env.VITE_API_KEY || '';

export interface VisitorCountResponse {
  count: number;
  previousCount: number;
}

/**
 * Increments the visitor count and returns the new count along with previous count
 * Returns null on error (silent error handling)
 */
export async function incrementAndGetVisitorCount(): Promise<VisitorCountResponse | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/visitor-count/increment`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY,
      },
    });

    if (!response.ok) {
      // Silent error handling - return null instead of throwing
      return null;
    }

    return await response.json();
  } catch (error) {
    // Silent error handling - return null instead of throwing
    return null;
  }
}

